import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApplicationRejectionType } from '../../../domain/qualification';

export type ApplicationResultState = {
  reason: string | null;
  rejectionType: ApplicationRejectionType | null;
  approved: boolean;
};

const initialState: ApplicationResultState = {
  rejectionType: null,
  reason: null,
  approved: false,
};

const slice = createSlice({
  name: 'applicationResult',
  initialState,
  reducers: {
    rejectLockedApplication: (state, { payload: reason }: PayloadAction<string>) => ({
      ...state,
      rejectionType: 'locked',
      reason,
    }),
    rejectInvalidApplication: (state, { payload: reason }: PayloadAction<string>) => ({
      ...state,
      rejectionType: 'invalid',
      reason,
    }),
    rejectIneligibleApplication: (state, { payload: reason }: PayloadAction<string>) => ({
      ...state,
      rejectionType: 'ineligible',
      reason,
    }),
    rejectUnsupportedApplication: (state, { payload: reason }: PayloadAction<string>) => ({
      ...state,
      rejectionType: 'unsupported_state',
      reason,
    }),
    rejectInactiveApplication: (state, { payload: reason }: PayloadAction<string>) => ({
      ...state,
      rejectionType: 'inactive_application',
      reason,
    }),
    approveApplication: (state) => ({
      ...state,
      approved: true,
    }),
    verifyApplication: (state) => ({
      ...state,
      approved: true,
    }),
  },
});

export const {
  rejectLockedApplication,
  rejectInvalidApplication,
  rejectIneligibleApplication,
  rejectUnsupportedApplication,
  approveApplication,
  verifyApplication,
  rejectInactiveApplication,
} = slice.actions;

export default slice.reducer;
